<div class="flex-row">
    <div>
        <sidebar-menu>
            <div class="sidebar-title">
                <hr />
                <div>Inventory</div>
            </div>

            <hr class="sidebar-hr" />

            <div class="sidebar-body">
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activePartnerMartInventoryMenu === partnerMartInventoryMenuEnum.AllProducts}"
                       (click)="onMenuClick(partnerMartInventoryMenuEnum.AllProducts)">All Products</a>
                </div>
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activePartnerMartInventoryMenu === partnerMartInventoryMenuEnum.Categories}"
                       (click)="onMenuClick(partnerMartInventoryMenuEnum.Categories)">Categories</a>
                </div>
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activePartnerMartInventoryMenu === partnerMartInventoryMenuEnum.Bundles}"
                       (click)="onMenuClick(partnerMartInventoryMenuEnum.Bundles)">Bundles</a>
                </div>
            </div>
        </sidebar-menu>
    </div>

    <div class="sidebar-next-right-block">
        <xpress-topbar style="width: 100vw; display: block; margin-bottom: 20px;"></xpress-topbar>

        <div class="root-body"
             [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
            <div class="inventory-products-block" *ngIf="activePartnerMartInventoryMenu === partnerMartInventoryMenuEnum.AllProducts">
                <merchant-products></merchant-products>
            </div>            
        </div>

    </div>
</div>
